<section class="card p-4 pdv-panel" aria-labelledby="pdv-sessions-title">
  <div class="pdv-panel__header"><h2 id="pdv-sessions-title" class="pdv-panel__title">Caixas do PDV</h2></div>
  <p class="pdv-panel__description">Consulte as vendas e a conferência de cada caixa de antecipados ou de portaria.</p>
  <div class="pdv-panel__filters">
    <label class="pdv-panel__field"
      >Fase
      <select class="form-select" [formControl]="phase">
        <option value="all">Todas</option>
        <option value="advance">Antecipados</option>
        <option value="portaria">Portaria</option>
      </select>
    </label>
    <label class="pdv-panel__field"
      >Operador
      <select class="form-select" [formControl]="operator">
        <option value="all">Todos</option>
        @for (entry of operators; track entry[0]) {
          <option [value]="entry[0]">{{ entry[1] }}</option>
        }
      </select>
    </label>
    <label class="pdv-panel__field"
      >Estado
      <select class="form-select" [formControl]="state">
        <option value="all">Todos</option>
        <option value="open">Abertos</option>
        <option value="closing_pending">Fechamento pendente</option>
        <option value="closed">Fechados</option>
        <option value="force_closed">Encerrados automaticamente</option>
      </select>
    </label>
    <div class="pdv-panel__filter-action">
      <app-button styleType="outlined" icon="pi pi-refresh" [disabled]="loading()" (btnClick)="load()"
        >Atualizar</app-button
      >
    </div>
  </div>
  @if (error()) {
    <p role="alert" class="pdv-panel__error">{{ error() }}</p>
  }
  @if (loading()) {
    <p role="status" class="pdv-panel__message">Carregando caixas…</p>
  }
  <div class="pdv-panel__summary">
    <span>Total de vendas pagas dos caixas filtrados</span
    ><strong class="pdv-panel__total">{{ totalCents / 100 | currency: "BRL" }}</strong>
  </div>
  <div class="pdv-panel__table" role="region" aria-label="Caixas do PDV" tabindex="0">
    <p-table [value]="filtered" [scrollable]="true" [stripedRows]="true" [tableStyle]="{ 'min-width': '75rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Sessão</th>
          <th>Operador</th>
          <th>Fase</th>
          <th>Estado</th>
          <th class="pdv-panel__money">Vendas pagas</th>
          <th class="pdv-panel__money">Dinheiro esperado</th>
          <th class="pdv-panel__money">Dinheiro contado</th>
          <th class="pdv-panel__money">Diferença</th>
          <th class="pdv-panel__count">Pagamentos pendentes</th>
          <th>Relatório</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td class="pdv-panel__identifier">#{{ row.id }}</td>
          <td>{{ row.operator_name }}</td>
          <td>{{ phaseNames[row.sales_phase] }}</td>
          <td>
            <span
              class="pdv-panel__badge"
              [class.pdv-panel__badge--success]="row.status === 'open'"
              [class.pdv-panel__badge--warning]="row.status === 'closing_pending'"
              >{{ statusNames[row.status] }}</span
            >
            @if (row.cash_limit_blocked && row.status === "open") {
              <div class="pdv-panel__error">Novas vendas bloqueadas por limite de dinheiro</div>
            }
          </td>
          <td class="pdv-panel__money">{{ row.sales_total_cents / 100 | currency: "BRL" }}</td>
          <td class="pdv-panel__money">{{ row.current_cash_cents / 100 | currency: "BRL" }}</td>
          <td class="pdv-panel__money">
            {{ row.counted_cash_cents === null ? "Não conferido" : (row.counted_cash_cents / 100 | currency: "BRL") }}
          </td>
          <td
            class="pdv-panel__money"
            [class.pdv-panel__negative]="row.difference_cents !== null && row.difference_cents < 0">
            {{ row.difference_cents === null ? "Não apurada" : (row.difference_cents / 100 | currency: "BRL") }}
          </td>
          <td class="pdv-panel__count">{{ row.pending_payments_count }}</td>
          <td>
            <app-button class="pdv-panel__session-action" icon="pi pi-eye" (btnClick)="openReport(row)"
              >Ver sessão</app-button
            >
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"
        ><tr>
          <td colspan="10" class="pdv-panel__empty">
            {{ loading() ? "Carregando caixas…" : "Nenhum caixa encontrado." }}
          </td>
        </tr></ng-template
      >
    </p-table>
  </div>
  @if (report(); as detail) {
    <section class="pdv-panel__report" aria-labelledby="pdv-report-title">
      <div class="pdv-panel__report-heading">
        <h3 id="pdv-report-title" class="pdv-panel__subtitle">Conferência da sessão #{{ detail.register.id }}</h3>
        <span>{{ detail.register.operator_name }} · {{ phaseNames[detail.register.sales_phase] }}</span>
      </div>
      <div class="pdv-panel__metrics">
        <div class="pdv-panel__metric">
          <span>Abertura</span><strong>{{ detail.movimentacao.opening_float_cents / 100 | currency: "BRL" }}</strong>
        </div>
        <div class="pdv-panel__metric">
          <span>Suprimentos</span><strong>{{ detail.movimentacao.suprimentos_cents / 100 | currency: "BRL" }}</strong>
        </div>
        <div class="pdv-panel__metric">
          <span>Sangrias</span><strong>{{ detail.movimentacao.sangrias_cents / 100 | currency: "BRL" }}</strong>
        </div>
      </div>
      <p class="pdv-panel__description">
        Ingressos: {{ detail.sales.tickets_count }} · Pedidos pagos: {{ detail.sales.orders_count }}
      </p>
      <div class="pdv-panel__table" role="region" aria-label="Pagamentos da sessão" tabindex="0">
        <p-table
          [value]="detail.sales.by_payment_method"
          [scrollable]="true"
          [stripedRows]="true"
          [tableStyle]="{ 'min-width': '28rem' }">
          <ng-template pTemplate="header"
            ><tr>
              <th>Pagamento</th>
              <th class="pdv-panel__count">Pedidos</th>
              <th class="pdv-panel__money">Total</th>
            </tr></ng-template
          >
          <ng-template pTemplate="body" let-payment
            ><tr>
              <td>{{ paymentNames[payment.payment_method] || payment.payment_method }}</td>
              <td class="pdv-panel__count">{{ payment.orders }}</td>
              <td class="pdv-panel__money">{{ payment.total_amount | currency: "BRL" }}</td>
            </tr></ng-template
          >
          <ng-template pTemplate="emptymessage"
            ><tr>
              <td colspan="3" class="pdv-panel__empty">Nenhum pagamento nesta sessão.</td>
            </tr></ng-template
          >
        </p-table>
      </div>
    </section>
  }
</section>
<app-pdv-terminal-sales [eventId]="eventId" />
